import * as React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

import { colors as Colors } from '../../themes/Colors';
import { SVGComponentProps } from '../type';

const LightningIcon = ({
  width = 16,
  height = 16,
  fill = Colors['light-green-600'],
  stroke
}: SVGComponentProps) => {
  const strokeColor = stroke || fill;

  return (
    <SVGUniqueID>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M9.49968 1.33203H5.66264C5.54298 1.33203 5.48316 1.33203 5.43034 1.35025C5.38363 1.36636 5.34109 1.39265 5.30579 1.42723C5.26587 1.46632 5.23912 1.51983 5.18561 1.62685L2.38561 7.22685C2.25782 7.48242 2.19393 7.61021 2.20927 7.71408C2.22268 7.80479 2.27285 7.88597 2.34798 7.93852C2.43403 7.9987 2.5769 7.9987 2.86264 7.9987H6.99968L4.99968 14.6654L13.1284 6.23557C13.4027 5.95117 13.5398 5.80896 13.5478 5.68729C13.5548 5.58167 13.5112 5.47902 13.4303 5.41072C13.3371 5.33203 13.1396 5.33203 12.7445 5.33203H7.99968L9.49968 1.33203Z"
          stroke={strokeColor}
          strokeWidth={1.33333}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SVGUniqueID>
  );
};

export { LightningIcon };
